import React, { useContext, useState, useEffect, useRef } from 'react';
import { Context } from '../../index';
import { useNavigate, useLocation } from 'react-router-dom';
import { getLinksByRole } from '../../utils/rolesConfig';
import { RoleType } from '../../utils/roles';
import HeaderLogo from './logo/logo';
import HeaderImage from './avatar/avatar';
import ButtonComponent from '../buttons/ButtonComponent';
import User from '../user/User';
import { observer } from 'mobx-react-lite';
import './styles.css';
import Modal from '../forms/wrap/Modal';

const DEFAULT_AVATAR = '/avatars/default.jpg'; // или путь к дефолтной аве

export default observer(function Header() {
  const AVAURL = process.env.REACT_APP_API_URL + '/uploads/images/avatars/';
  const { store } = useContext(Context);
  const navigate = useNavigate();
  const location = useLocation();

  const [userPhoto, setUserPhoto] = useState(DEFAULT_AVATAR);
  const [links, setLinks] = useState([]);

  const generateAvatarUrl = (userId) => {
    if (!userId) return DEFAULT_AVATAR;
    return `${AVAURL}${userId}.jpg?_=${Date.now()}`;
  };

  useEffect(() => {
    setUserPhoto(generateAvatarUrl(store.user?.id));
  }, [store.isAuth, store.user?.id, AVAURL]);

  useEffect(() => {
    if (store.user?.role) {
      const availableLinks = getLinksByRole(store.user.role as RoleType);
      setLinks(availableLinks);
    }
  }, [store.user?.role]);

  const handleNavigate = (link) => {
    navigate(link);
  };

  const [isVisible, setVisible] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const touchStartX = useRef(0);
  const touchStartY = useRef(0);

  const openUser = () => {
    setVisible(!isVisible);
  };

  useEffect(() => {
    const handleTouchStart = (e: TouchEvent) => {
      touchStartX.current = e.touches[0].clientX;
      touchStartY.current = e.touches[0].clientY;
    };

    const handleTouchEnd = (e: TouchEvent) => {
      const endX = e.changedTouches[0].clientX;
      const endY = e.changedTouches[0].clientY;
      const diffX = endX - touchStartX.current;
      const diffY = endY - touchStartY.current;

      // игнорируем вертикальные свайпы
      if (Math.abs(diffY) > Math.abs(diffX)) return;

      // свайп вправо от левого края — открыть
      if (!menuOpen && diffX > 60 && touchStartX.current < 30) {
        setMenuOpen(true);
      }

      // свайп влево — закрыть
      if (menuOpen && diffX < -60) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchend', handleTouchEnd);
    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [menuOpen]);

  const updateUserPhoto = () => {
    setUserPhoto(generateAvatarUrl(store.user?.id));
  };

  const fullName = [store.user?.lastName, store.user?.firstName, store.user?.surName]
    .filter(Boolean) // на случай, если какие-то поля undefined
    .join(' ');

  return (
    <header className="header_conteiner">
      <HeaderLogo />

      <div className='header_logobtns'>
        {store.isAuth ? (
          <>
            <div className='header_navbar desktop-only'>
              <div className='header_links'>
                {links.map((el) => (
                  <ButtonComponent
                    key={el.link}
                    title={el.title}
                    svg={el.img}
                    onClick={() => handleNavigate(el.link)}
                    type={location.pathname === el.link ? 'active' : null}
                  />
                ))}
              </div>
            </div>
            <button
              className='burger-btn mobile-only'
              onClick={() => setMenuOpen(true)}
              aria-label='Открыть меню'
            >
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M3 6H21M3 12H21M3 18H21' stroke='currentColor' strokeWidth='2' strokeLinecap='round'/>
              </svg>
            </button>
          </>
        ) : (
          <div></div>
        )}
      </div>

      <div>
        {store.isAuth ? (
          <div className='header_profile'>
            <ButtonComponent
              title='выйти'
              onClick={async () => {
                await store.logout();
                navigate('/');
              }}
              type='out'
            />
            <HeaderImage
              Click={openUser}
              imageUrl={userPhoto}
              menuUrl="/usermenu.svg"
            />
          </div>
        ) : null}

      </div>
      {isVisible && (
        <Modal isOpen={isVisible} onClose={openUser}>
          <User
            fullName={fullName}
            organization={store.company?.name}
            role={store.user?.role}
            photo={userPhoto}
            phone={store.user?.tel}
            email={store.user?.email}
            updatePhoto={updateUserPhoto}
            openUser={openUser}
          />
        </Modal>
      )}

      {store.isAuth && (
        <>
          <div
            className={`mobile-drawer-overlay ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(false)}
          />
          <div className={`mobile-drawer ${menuOpen ? 'open' : ''}`}>
            <div className='mobile-drawer-header'>
              <span>Меню</span>
              <button
                className='drawer-close'
                onClick={() => setMenuOpen(false)}
                aria-label='Закрыть меню'
              >
                <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path d='M2 2L18 18M18 2L2 18' stroke='currentColor' strokeWidth='2' strokeLinecap='round'/>
                </svg>
              </button>
            </div>
            <div className='mobile-drawer-links'>
              {links.map((el) => (
                <ButtonComponent
                  key={el.link}
                  title={el.title}
                  svg={el.img}
                  onClick={() => {
                    handleNavigate(el.link);
                    setMenuOpen(false);
                  }}
                  type={location.pathname === el.link ? 'active' : null}
                />
              ))}
            </div>
          </div>
        </>
      )}

    </header>

  );
});
